// @ts-ignore: Internals is exported... argh.
import ClassAdder, { internals } from './ClassAdder.svelte';
const defaults = Object.assign({}, internals);
export function classAdderBuilder(props) {
    return new Proxy(ClassAdder, {
        construct: function (target, args) {
            Object.assign(internals, defaults, props);
            // @ts-ignore: Need spread arg.
            return new target(...args);
        },
        get: function (target, prop) {
            Object.assign(internals, defaults, props);
            return target[prop];
        },
    });
}
//# sourceMappingURL=classAdderBuilder.js.map